import { memo } from "react";

import { totalFacilitiesCountAtom, totalWellsCountAtom } from "atoms";
import { useAtomValue } from "jotai";

import "./Indicator.scss";

function Indicator({
  map = false,
  message = "",
  hasRigFracInView = false
}: {
  map?: boolean;
  message?: string;
  hasRigFracInView?: boolean;
}) {
  const totalWellCount = useAtomValue(totalWellsCountAtom);
  const totalFacilityCount = useAtomValue(totalFacilitiesCountAtom);
  if (map && (totalWellCount > 0 || totalFacilityCount > 0 || hasRigFracInView)) {
    return <></>;
  }
  return (
    <div data-testid={"indicator-container"} className="indicator-container">
      <div className="content">{message}</div>
    </div>
  );
}
export default memo(Indicator);
